var _path, _rect;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgYoutube = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "youtube",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "youtube-2",
    "data-name": "youtube",
    d: "M14.692-4.439A1.879,1.879,0,0,0,13.37-5.761,43.906,43.906,0,0,0,7.5-6.082a45.616,45.616,0,0,0-5.869.309A1.917,1.917,0,0,0,.31-4.439,19.8,19.8,0,0,0,0-.831,19.728,19.728,0,0,0,.31,2.777,1.879,1.879,0,0,0,1.632,4.1,43.985,43.985,0,0,0,7.5,4.42a45.616,45.616,0,0,0,5.869-.309,1.879,1.879,0,0,0,1.322-1.322A19.807,19.807,0,0,0,15-.818a18.8,18.8,0,0,0-.309-3.62ZM6.006,1.418v-4.5L9.91-.831Zm0,0",
    transform: "translate(7.499 15.457)",
    fill: "#ea3333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 30,
    height: 30,
    fill: "none"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgYoutube, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/youtube.79b82bb4.svg";
export { ForwardRef as ReactComponent };